import React from "react";
import { Card, Tag, Popconfirm, Button, Space, Typography } from "antd";
import { DeleteOutlined, CheckCircleOutlined, ExclamationCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { format, parseISO } from "date-fns";

const { Title, Text } = Typography;

const MoveDateCard = ({ data, getCompanyStatus, deleteUser }) => {
  const moveInfo = data?.moveinInfo?.[0];
  const status = getCompanyStatus(moveInfo?.companies);

  const statusTag = () => {
    if (status === "Completed")
      return <Tag icon={<CheckCircleOutlined />} color="success">Completed</Tag>;
    if (status === "Action needed")
      return <Tag icon={<ExclamationCircleOutlined />} color="warning">Action Needed</Tag>;
    return <Tag icon={<ClockCircleOutlined />} color="processing">In Progress</Tag>;
  };

  return (
    <Card
      title="Move Date"
      extra={
        <Popconfirm
          title="Are you sure you want to delete this user?"
          onConfirm={() => deleteUser(data._id)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="text" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      }
    >
      <Space direction="vertical" size="small">
        <Title level={2} style={{ margin: 0 }}>
          {moveInfo?.movingDate ? format(parseISO(moveInfo.movingDate), "do") : "--"}
        </Title>
        <Title level={4} style={{ margin: 0, color: "#666" }}>
          {moveInfo?.movingDate ? format(parseISO(moveInfo.movingDate), "MMM yyyy") : "--"}
        </Title>
        <Text type="secondary">Status</Text>
        {statusTag()}
      </Space>
    </Card>
  );
};

export default MoveDateCard;
